// extracted by mini-css-extract-plugin
var _1 = "AuthTitle-moduleAuthTitle__VKaTa";
export { _1 as "AuthTitle" }
